<template>
  <div id="new-lo-title-report" class="report-container">
    <overlay-loading-progress :LoadingFlag="RegenerateLoadingFlag"
      LoadingText="Regenerating Application Form..."></overlay-loading-progress>

    <!-- Premium Header with Title and Actions -->
    <v-card elevation="20" class="premium-header-card mb-6 overflow-hidden">
      <div class="header-gradient-bg">
        <div class="header-backdrop-effect"></div>
        <div class="header-content pa-8">
          <div class="header-top d-flex align-center justify-space-between">
            <!-- Left: Title Section -->
            <div class="title-section d-flex align-center">
              <div class="title-icon-box">
                <v-icon x-large color="white">mdi-file-document</v-icon>
              </div>
              <div class="title-text ml-4">
                <h1 class="header-title mb-1">{{ PageTitle }}</h1>
                <p class="header-subtitle mb-0">{{ PageDescription }}</p>
              </div>
            </div>

            <!-- Right: Action Buttons -->
            <div class="action-buttons-group d-flex align-center gap-2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon large @click.prevent="refreshPageData" class="action-btn refresh-btn" v-bind="attrs"
                    v-on="on">
                    <v-icon color="white">mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Refresh Data</span>
              </v-tooltip>

              <router-link to="/lom/create">
                <v-btn elevation="8" class="premium-btn premium-btn-gradient">
                  <v-icon left>mdi-domain</v-icon>
                  <span class="btn-text">Manual LO Create</span>
                </v-btn>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Preview Dialog -->
    <v-dialog v-model="titlePreviewRecordPrompt" persistent max-width="75%">
      <new-lo-title-preview :pageTitle="titlePreviewRecordPageTitle" :previewFlag="titlePreviewFlag"
        :recordData="selectedData" @hidePreviewRecordPrompt="hideTitlePreviewRecordPrompt"
        @hideEditRecordPrompt="hideTitleEditRecordPrompt" v-if="titlePreviewRecordPrompt"></new-lo-title-preview>
    </v-dialog>

    <!-- Main Content Card -->
    <v-card elevation="12" class="main-content-card">
      <v-card-text>
        <!-- Loading State -->
        <div v-if="LoadingFlag" class="text-center py-12">
          <v-progress-circular indeterminate size="64" color="#667eea"></v-progress-circular>
          <p class="mt-6 text-h6 font-weight-600" style="color: #667eea">
            Loading data...
          </p>
        </div>

        <!-- Search Form Section -->
        <v-container class="py-0" v-if="SearchFormFlag">
          <v-card elevation="8" class="search-form-card">
            <v-card-text class="pa-8">
              <div class="search-form-header d-flex align-center mb-6">
                <v-icon color="#667eea" class="mr-3">mdi-filter-variant</v-icon>
                <h3 class="mb-0" style="color: #333">Filter Records</h3>
              </div>
              <hr />
              <v-form ref="form2" v-model="valid1" lazy-validation>
                <v-row wrap>
                  <!-- Payment Type -->
                  <v-col cols="12" sm="6" md="3">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <v-icon small color="#667eea" class="mr-1">mdi-tag-multiple</v-icon>
                        Payment Type <small>(Optional)</small>
                      </label>
                      <v-autocomplete :reduce="(option) => option.value" :items="PaymentTypeOptions"
                        :rules="PaymentTypeRules" v-model="PaymentType" required outlined dense
                        prepend-inner-icon="mdi-receipt" class="premium-input"
                        background-color="#FAFBFC"></v-autocomplete>
                    </div>
                  </v-col>

                  <!-- From Date -->
                  <v-col cols="12" sm="6" md="3">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <v-icon small color="#667eea" class="mr-1">mdi-calendar-start</v-icon>
                        <span class="required-indicator">*</span> From Date
                      </label>
                      <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" lazy
                        transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field required v-model="FromDate" label="Select From Date" readonly v-on="on" outlined
                            dense prepend-inner-icon="mdi-calendar" class="premium-input"
                            background-color="#FAFBFC"></v-text-field>
                        </template>
                        <v-date-picker v-model="FromDate" @input="menu1 = false"></v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>

                  <!-- To Date -->
                  <v-col cols="12" sm="6" md="3">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <v-icon small color="#667eea" class="mr-1">mdi-calendar-end</v-icon>
                        <span class="required-indicator">*</span> To Date
                      </label>
                      <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" lazy
                        transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field required v-model="ToDate" label="Select To Date" readonly v-on="on" outlined
                            dense prepend-inner-icon="mdi-calendar" class="premium-input"
                            background-color="#FAFBFC"></v-text-field>
                        </template>
                        <v-date-picker v-model="ToDate" @input="menu2 = false"></v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>

                  <!-- Zone Filter -->
                  <v-col cols="12" sm="6" md="3">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <v-icon small color="#667eea" class="mr-1">mdi-map-marker</v-icon>
                        Zone <small>(Optional)</small>
                      </label>
                      <v-autocomplete :reduce="(option) => option.value" :items="ZoneCodeOptions" :rules="ZoneCodeRules"
                        :loading="ZoneCodeOptionsLoading" v-model="ZoneCode" hint="Select zone" dense clearable required
                        outlined prepend-inner-icon="mdi-domain" class="premium-input"
                        background-color="#FAFBFC"></v-autocomplete>
                    </div>
                  </v-col>
                </v-row>

                <!-- Search Button -->
                <v-row wrap class="mt-4">
                  <v-col align="center" cols="12">
                    <v-btn :disabled="!valid1" @click.prevent="searchForm(2)" :loading="SearchFlag" color="#667eea"
                      elevation="8" large class="search-btn font-weight-600 px-12">
                      <v-icon left>mdi-magnify</v-icon>
                      Search Records
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Results Section -->
        <v-container class="py-0 mt-8" v-if="ResultFlag">
          <!-- No Records Found -->
          <v-card v-if="rows.length === 0" elevation="4" class="empty-state-card">
            <v-card-text class="text-center py-12">
              <v-icon x-large color="#ccc" class="mb-4">mdi-file-document-outline</v-icon>
              <h4 class="text-h6 font-weight-600 mb-2" style="color: #666">
                No records found
              </h4>
              <p style="color: #999">
                Try adjusting your filter criteria and search again
              </p>
            </v-card-text>
          </v-card>

          <!-- Records Found -->
          <div v-if="rows.length > 0">
            <!-- Summary Bar -->
            <v-card elevation="0" class="summary-bar mb-6">
              <v-card-text class="pa-6">
                <div class="d-flex align-center justify-space-between flex-wrap">
                  <div class="summary-info">
                    <v-icon color="#667eea" class="mr-2">mdi-file-multiple</v-icon>
                    <span class="font-weight-600" style="color: #333">{{ rows.length }} records found</span>
                  </div>
                  <v-btn v-if="ExcelDownloadFlag" color="#10b981" elevation="6" class="font-weight-600 ml-4"
                    @click.prevent="
                      generateExcel(rows, ExcelFields, ExcelFileName, 'Records')
                      ">
                    <v-icon left>mdi-download</v-icon>
                    Download Excel
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>

            <!-- Search Bar -->
            <v-card elevation="4" class="search-bar-card mb-6">
              <v-card-text class="pa-6">
                <v-text-field v-model="search" label="Search records..." prepend-inner-icon="mdi-magnify" outlined dense
                  class="premium-input" background-color="#FAFBFC"></v-text-field>
              </v-card-text>
            </v-card>

            <!-- Data Table -->
            <v-card elevation="8" class="data-table-card">
              <v-data-table class="premium-data-table" loading-text="Loading records... Please wait" v-model="selected"
                :search="search" :show-select="FloatingButtonOptions.ShowSelectFlag" :loading="TableLoadingFlag"
                :item-key="tableOptions1.ItemKey" :single-select="tableOptions1.SingleSelectFlag"
                :headers="tableColumns1" :items="rows" :items-per-page="tableOptions1.ItemsPerPage"
                :footer-props="tableOptions1.FooterProps">
                <!-- Status Column -->
                <template v-slot:item.ActiveStatusTxt="{ item }">
                  <v-chip :color="getActiveStatusColor(item.ActiveStatusTxt)" text-color="white" small
                    class="font-weight-600">
                    {{ item.ActiveStatusTxt }}
                  </v-chip>
                </template>

                <!-- Profile Picture Column -->
                <template v-slot:item.ProfilePic="{ item }">
                  <div class="profile-pic-container">
                    <img v-if="item.ProfilePic" :src="item.ProfilePic" class="profile-image" />
                    <v-icon v-else color="#ccc">mdi-account-circle</v-icon>
                  </div>
                </template>

                <!-- Actions Column -->
                <template v-slot:item.actions="{ item }">
                  <div class="action-buttons-container">
                    <!-- Receipt Download -->
                    <v-tooltip bottom v-if="item.ReceiptPath != ''">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn :href="item.ReceiptPath" target="_blank" icon small color="#e74c3c" class="action-btn"
                          v-bind="attrs" v-on="on">
                          <v-icon small>mdi-file-pdf</v-icon>
                        </v-btn>
                      </template>
                      <span>Download Receipt</span>
                    </v-tooltip>

                    <!-- Application Download -->
                    <v-tooltip bottom v-if="item.ApplicationPath != ''">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn :href="item.ApplicationPath" target="_blank" icon small color="#3498db"
                          class="action-btn" v-bind="attrs" v-on="on">
                          <v-icon small>mdi-cloud-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Download Application</span>
                    </v-tooltip>

                    <!-- Preview -->
                    <v-tooltip bottom v-if="item.PreviewFlag">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="titlePreviewData(item, 1)" icon small color="#f39c12" class="action-btn"
                          v-bind="attrs" v-on="on">
                          <v-icon small>mdi-file-search</v-icon>
                        </v-btn>
                      </template>
                      <span>Preview Details</span>
                    </v-tooltip>

                    <!-- Confirmation -->
                    <v-tooltip bottom v-if="item.TitleConfirmationFlag">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="titlePreviewData(item, 3)" icon small color="#2196f3" class="action-btn"
                          v-bind="attrs" v-on="on">
                          <v-icon small>mdi-file-check</v-icon>
                        </v-btn>
                      </template>
                      <span>Confirm</span>
                    </v-tooltip>

                    <!-- Approve -->
                    <v-tooltip bottom v-if="item.TitleApprovalFlag || item.PaymentApprovalFlag">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="titlePreviewData(item, 2)" icon small color="#27ae60" class="action-btn"
                          v-bind="attrs" v-on="on">
                          <v-icon small>mdi-file-check</v-icon>
                        </v-btn>
                      </template>
                      <span>Approve</span>
                    </v-tooltip>

                    <!-- Regenerate Application -->
                    <v-tooltip bottom v-if="item.OrdersType == 4">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="regenerateApplication(item)" icon small color="#8e44ad" class="action-btn"
                          v-bind="attrs" v-on="on">
                          <v-icon small>mdi-refresh</v-icon>
                        </v-btn>
                      </template>
                      <span>Regenerate Application</span>
                    </v-tooltip>

                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-container>

        <br /><br />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import NewLoTitlePreview from "@/view/pages/erp/new_lo_title/NewLoTitlePreview.vue";

export default {
  mixins: [common],
  components: {
    NewLoTitlePreview,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,
      SearchFormFlag: false,
      DownloadFlag: true,
      RegenerateLoadingFlag: false,


      rows: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,
      TableLoadingFlag: false,

      SpeedDialFlag: false,
      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      addRecordPrompt: false,
      editRecordPrompt: false,

      titlePreviewRecordPrompt: false,
      titlePreviewRecordPageTitle: "",
      titlePreviewFlag: false,
      selectedData: {},

      ExcelDownloadFlag: false,
      ExcelFileName: "",
      ExcelFields: {},

      PaymentTypeRules: [],
      PaymentType: "",
      PaymentTypeOptions: [
        { value: "", text: "--Select Payment Type--" },
        { value: 1, text: "New LO Title" },
        { value: 2, text: "New LO Payment" },
      ],
      PaymentTypeOptionsLoading: false,

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      FromDate: "",
      FromDateRules: [(v) => !!v || "From date is required"],
      menu1: false,

      ToDate: "",
      ToDateRules: [(v) => !!v || "To date is required"],
      menu2: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
    };
  },
  mounted() { },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        console.log("RoleId=" + RoleId);

        if (RoleId == 1 || RoleId == 2 || RoleId == 4) {
          this.SearchFormFlag = true;
          this.getZoneCodeOptions();
        } else {
          var ZoneCode = this.$session.get("ZoneId");
          ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
          console.log("ZoneCode=" + ZoneCode);
          this.ZoneCode = ZoneCode;
          this.searchForm(3);
        }
      }
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.LoadingFlag = false;
      this.ZoneCodeOptionsLoading = false;
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      this.getTableRecords();
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "new_lo_title",
        Action: "report_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    hideTitleEditRecordPrompt() {
      console.log("hideTitleEditRecordPrompt called");
      this.titlePreviewRecordPrompt = false;
      var RoleId = this.$session.get("RoleId");
      RoleId = RoleId == (null || undefined) ? "" : RoleId;
      console.log("RoleId=" + RoleId);

      if (RoleId == 1 || RoleId == 2 || RoleId == 4) {
        this.searchForm(2);
      } else {
        this.searchForm(3);
      }
    },
    hideTitlePreviewRecordPrompt() {
      console.log("hideTitlePreviewRecordPrompt called");
      this.titlePreviewRecordPrompt = false;
    },
    titlePreviewData(tr, type) {
      console.log("titlePreviewData called");
      console.log({ type });
      var OrderType = tr.OrdersType;
      console.log({ OrderType });
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var pageTitle = "";
        var previewFlag = false;
        if (type == 1) {
          previewFlag = true; //
          pageTitle =
            OrderType == 3
              ? "Preview New LO Title Details"
              : "Preview New LO Payment Details";
        } else if (type == 2) {
          pageTitle =
            OrderType == 3
              ? "Approve New LO Title Details"
              : "Approve New LO Payment Details";
        } else {
          pageTitle =
            OrderType == 3
              ? "Confirmation New LO Title Details"
              : "Confirmation New LO Payment Details";
        }
        this.titlePreviewRecordPrompt = true;
        this.titlePreviewFlag = previewFlag;
        this.titlePreviewRecordPageTitle = pageTitle;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      console.log("CurrentYearId=" + this.CurrentYearId);
      this.LoadingFlag = true;
      this.ZoneCodeOptionsLoading = true;
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/year-wise-lom/zone-options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
        YearCode: this.CurrentYearId,
        NotAvailable: 1,
        AllZones: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    searchForm(status) {
      console.log("searchForm is called");

      var validate1 = true;
      if (status != 3) {
        validate1 = this.$refs.form2.validate();
        console.log("validate1=" + validate1);
      }

      var FromDate = this.FromDate;
      var ToDate = this.ToDate;

      if ((validate1 && FromDate != "" && ToDate != "") || status == 3) {
        // this.SearchFlag = true;
        this.LoadingFlag = true;
        this.rows = [];
        this.ExcelFileName = "";
        this.ExcelDownloadFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/new-lom/lists";
        var upload = {
          UserInterface: status,
          Zone: this.ZoneCode,
          FromDate: FromDate,
          ToDate: ToDate,
          PaymentType: this.PaymentType,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.LoadingFlag = false;
            thisIns.ResultFlag = true;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.table_content;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            var options = records.TableOptions;
            thisIns.tableOptions1 = options;

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.rows = records.TableData;

              thisIns.ExcelDownloadFlag = options.ExcelDownloadFlag;
              thisIns.ExcelFileName = options.ExcelFileName;
              thisIns.ExcelFields = options.ExcelFields;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
    regenerateApplication(item) {
      console.log("regenerateApplication called");
      console.log({ item });

      this.RegenerateLoadingFlag = true;


      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/new-lom/regenerate-provisional-form";
      var upload = {
        UserInterface: 1,
        JmOrdersId: item.JmOrdersId,
      };

      const thisIns = this;
      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.RegenerateLoadingFlag = false;


          var flag = response.data.flag;
          var output = response.data.output;

          if (flag == 1) {
            thisIns.toast("success", output);
            var RoleId = thisIns.$session.get("RoleId");
            RoleId = RoleId == (null || undefined) ? "" : RoleId;

            if (RoleId == 1 || RoleId == 2 || RoleId == 4) {
              thisIns.searchForm(2);
            } else {
              thisIns.searchForm(3);
            }
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.RegenerateLoadingFlag = false;
          thisIns.toast("error", "Some problem in API call");
        });
    },
  },

  beforeMount() {
    var todayDate = new Date().toISOString().slice(0, 10);
    console.log(todayDate);

    this.FromDate = todayDate;
    this.ToDate = todayDate;

    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
// Color Palette
$primary-color: #667eea;
$secondary-color: #764ba2;
$gradient-main: linear-gradient(135deg,
    $primary-color 0%,
    $secondary-color 100%);
$success-color: #10b981;
$warning-color: #f39c12;
$danger-color: #e74c3c;
$info-color: #3498db;
$light-bg: #f5f7fa;
$card-shadow: 0 12px 40px rgba(102, 126, 234, 0.2);
$text-dark: #333;
$text-light: #666;

// Animation Keyframes
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

#new-lo-title-report {
  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
  min-height: 100vh;
  padding: 30px 15px;

  // Premium Header Styles
  .premium-header-card {
    background: $gradient-main !important;
    border-radius: 16px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(102, 126, 234, 0.4);

    .header-gradient-bg {
      position: relative;
      overflow: hidden;

      .header-backdrop-effect {
        position: absolute;
        top: -50%;
        right: -10%;
        width: 300px;
        height: 300px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        animation: float 6s ease-in-out infinite;
      }
    }

    .header-content {
      position: relative;
      z-index: 1;

      .header-top {
        align-items: center;
        justify-content: space-between;

        .title-section {
          align-items: center;
          flex: 1;

          .title-icon-box {
            background: rgba(255, 255, 255, 0.2);
            padding: 16px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(10px);
          }

          .title-text {
            .header-title {
              color: white;
              font-size: 2rem;
              font-weight: 700;
              margin: 0;
            }

            .header-subtitle {
              color: rgba(255, 255, 255, 0.9);
              font-size: 1rem;
              font-weight: 400;
            }
          }
        }

        .action-buttons-group {
          gap: 12px;

          .action-btn {
            background: rgba(255, 255, 255, 0.15) !important;
            backdrop-filter: blur(10px);
            transition: all 0.3s ease;

            &:hover {
              background: rgba(255, 255, 255, 0.25) !important;
              transform: translateY(-2px);
            }
          }
        }
      }
    }
  }

  // Main Content Card
  .main-content-card {
    border-radius: 14px;
    background: white !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    animation: fadeIn 0.6s ease-in-out;
  }

  // Search Form Styles
  .search-form-card {
    border-radius: 14px;
    background: white !important;
    box-shadow: $card-shadow;
    border: none;
    animation: fadeIn 0.6s ease-in-out 0.2s backwards;

    .search-form-header {
      align-items: center;
      margin-bottom: 24px;

      h3 {
        color: $text-dark;
        font-weight: 600;
        font-size: 1.25rem;
      }
    }

    .form-field-wrapper {
      margin-bottom: 0;

      .form-label {
        display: flex;
        align-items: center;
        color: $text-dark;
        font-weight: 600;
        font-size: 0.95rem;
        margin-bottom: 8px;

        .required-indicator {
          color: $danger-color;
          margin-right: 4px;
        }

        small {
          color: $text-light;
          font-weight: 400;
          margin-left: 4px;
        }
      }

      .premium-input {
        border-radius: 8px;

        &::placeholder {
          color: #bbb;
        }
      }
    }

    .search-btn {
      background: linear-gradient(135deg,
          $primary-color 0%,
          $secondary-color 100%);
      color: white;
      border-radius: 8px;
      transition: all 0.3s ease;
      box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 28px rgba(102, 126, 234, 0.4);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }

  // Results Section Styles
  .summary-bar {
    background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
    border-radius: 12px;
    border-left: 4px solid $primary-color;

    .summary-info {
      display: flex;
      align-items: center;
      color: $text-dark;
      font-size: 1.1rem;
    }
  }

  .search-bar-card {
    border-radius: 14px;
    background: white !important;
    box-shadow: $card-shadow;

    .premium-input {
      border-radius: 8px;
    }
  }

  // Data Table Styles
  .data-table-card {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: $card-shadow;
    border: none;

    ::v-deep .premium-data-table {
      background: white;

      // Header Styling
      thead tr {
        background: linear-gradient(135deg,
            #f8f9ff 0%,
            #f0f4ff 100%) !important;
        border-bottom: 2px solid $primary-color;

        th {
          color: $primary-color !important;
          font-weight: 700 !important;
          text-transform: uppercase;
          font-size: 0.85rem !important;
          letter-spacing: 0.5px;
        }
      }

      // Row Styling
      tbody tr {
        border-bottom: 1px solid #eee;
        transition: all 0.3s ease;

        &:hover {
          background: #f8f9ff !important;
          box-shadow: inset 0 0 10px rgba(102, 126, 234, 0.05);
        }

        td {
          padding: 16px !important;
          color: $text-dark;
          font-weight: 500;
        }
      }

      // Status Chip
      .v-chip {
        font-weight: 600 !important;
      }

      // Loading State
      .v-progress-linear {
        background: linear-gradient(90deg,
            $primary-color 0%,
            $secondary-color 100%);
      }
    }
  }

  // Profile Picture Container
  .profile-pic-container {
    display: flex;
    align-items: center;
    justify-content: center;

    .profile-image {
      width: 56px;
      height: 56px;
      border-radius: 8px;
      object-fit: cover;
      border: 2px solid #eee;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  // Action Buttons Container
  .action-buttons-container {
    display: flex;
    gap: 4px;
    align-items: center;
    flex-wrap: wrap;

    .action-btn {
      transition: all 0.3s ease;
      border-radius: 6px;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }

  // Empty State
  .empty-state-card {
    border-radius: 14px;
    border: 2px dashed #ddd;
    background: #fafbfc !important;
  }

  // Responsive Design
  @media (max-width: 1200px) {
    .premium-header-card .header-content .header-top {
      flex-direction: column;
      text-align: left;

      .action-buttons-group {
        margin-top: 16px;
        justify-content: flex-start;
      }
    }
  }

  @media (max-width: 960px) {
    padding: 20px 12px;

    .premium-header-card {
      margin-bottom: 20px;

      .header-content {
        padding: 24px !important;
      }
    }

    .search-form-card {
      .search-btn {
        width: 100%;
      }
    }

    ::v-deep .premium-data-table {
      font-size: 0.9rem !important;

      td,
      th {
        padding: 12px !important;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 16px 8px;

    .premium-header-card {
      .header-content {
        padding: 16px !important;

        .title-section {
          flex-direction: column;
          text-align: center;

          .title-text {
            margin-left: 0;
            margin-top: 12px;

            .header-title {
              font-size: 1.5rem;
            }
          }
        }

        .action-buttons-group {
          margin-top: 12px;
          justify-content: center;
          width: 100%;
        }
      }
    }

    .action-buttons-container {
      .action-btn {
        width: 36px;
        height: 36px;
      }
    }
  }

  // Float Animation
  @keyframes float {

    0%,
    100% {
      transform: translateY(0px);
    }

    50% {
      transform: translateY(-20px);
    }
  }
}
</style>